import React from 'react';
import { Sparkles, Plus, Edit2, Trash2, Calendar, MessageSquare } from 'lucide-react';

const LooksTab = ({ looks, wardrobeItems, onAdd, onDelete, onEdit }) => (
  <div>
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--space-l)' }}>
      <button
        onClick={onAdd}
        data-testid="add-look-btn"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--space-s)',
          padding: '10px 16px',
          backgroundColor: 'var(--black)',
          color: 'var(--white)',
          border: 'none',
          fontFamily: 'var(--font-body)',
          fontSize: '0.8125rem',
          cursor: 'pointer'
        }}
      >
        <Plus size={16} />
        Создать образ
      </button>
    </div>

    {looks.length === 0 ? (
      <div style={{ textAlign: 'center', padding: 'var(--space-xxl)', backgroundColor: 'var(--white)', border: '1px solid var(--soft-gray)' }}>
        <Sparkles size={48} style={{ color: 'var(--light-gray)', marginBottom: 'var(--space-l)' }} />
        <p style={{ fontFamily: 'var(--font-display)', fontSize: '1.25rem' }}>Нет образов</p>
      </div>
    ) : (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'var(--space-l)' }}>
        {looks.map((look) => (
          <div key={look.id} style={{ backgroundColor: 'var(--white)', border: '1px solid var(--soft-gray)', overflow: 'hidden', position: 'relative' }}>
            <div style={{ position: 'absolute', top: '8px', right: '8px', display: 'flex', gap: '4px', zIndex: 1 }}>
              <button
                onClick={() => onEdit(look)}
                style={{
                  padding: '6px',
                  backgroundColor: 'rgba(255,255,255,0.9)',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                <Edit2 size={14} style={{ color: 'var(--mid-gray)' }} />
              </button>
              <button
                onClick={() => onDelete(look.id)}
                style={{
                  padding: '6px',
                  backgroundColor: 'rgba(255,255,255,0.9)',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                <Trash2 size={14} style={{ color: '#ef4444' }} />
              </button>
            </div>
            {look.look_images?.[0] && (
              <div style={{ height: '200px', overflow: 'hidden', backgroundColor: 'var(--cream)' }}>
                <img src={look.look_images[0]} alt={look.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
            )}
            <div style={{ padding: 'var(--space-m)' }}>
              <h4 style={{ fontFamily: 'var(--font-display)', fontSize: '1.125rem', marginBottom: 'var(--space-s)' }}>
                {look.name}
              </h4>
              {look.description && (
                <p style={{ fontFamily: 'var(--font-body)', fontSize: '0.8125rem', color: 'var(--mid-gray)', marginBottom: 'var(--space-m)' }}>
                  {look.description}
                </p>
              )}
              {look.event_types?.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-xs)', marginBottom: 'var(--space-m)' }}>
                  {look.event_types.map((event, idx) => (
                    <span key={idx} style={{ padding: '4px 8px', backgroundColor: 'var(--cream)', fontSize: '0.75rem' }}>
                      {event}
                    </span>
                  ))}
                </div>
              )}
              {look.wardrobe_items?.length > 0 && (
                <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                  {look.wardrobe_items.slice(0, 4).map((item) => (
                    <div key={item.id} style={{ width: '40px', height: '40px', overflow: 'hidden', borderRadius: '4px' }}>
                      <img src={item.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                  ))}
                  {look.wardrobe_items.length > 4 && (
                    <div style={{ width: '40px', height: '40px', backgroundColor: 'var(--cream)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem' }}>
                      +{look.wardrobe_items.length - 4}
                    </div>
                  )}
                </div>
              )}
              {look.request_id && (
                <div style={{
                  marginTop: 'var(--space-m)',
                  padding: '6px 10px',
                  backgroundColor: '#3b82f615',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '0.75rem',
                  color: '#3b82f6'
                }}>
                  <MessageSquare size={12} />
                  По запросу клиента
                </div>
              )}
              <div style={{ marginTop: 'var(--space-m)', display: 'flex', alignItems: 'center', gap: 'var(--space-xs)', fontSize: '0.75rem', color: 'var(--light-gray)' }}>
                <Calendar size={12} />
                {new Date(look.created_at).toLocaleDateString('ru-RU')}
              </div>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default LooksTab;
